import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import { Mail, Phone, MapPin } from "lucide-react";
import { platformIcon, platformLabel } from "./SocialIcons";

export const Footer = ({ contact, logoUrl, socialLinks = [] }) => {
  const visibleSocial = (socialLinks || []).filter((l) => l && l.url && l.url.trim());
  return (
    <footer className="border-t border-white/10 bg-[#0B1020]" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 md:grid-cols-4">
        <div className="md:col-span-2">
          <Logo src={logoUrl} />
          <p className="mt-5 max-w-md text-sm leading-relaxed text-white/60">
            A full-service digital agency building distinctive brands, modern websites, and
            growth-driven marketing for ambitious teams.
          </p>
          {visibleSocial.length > 0 && (
            <div className="mt-6 flex flex-wrap gap-2" data-testid="footer-social">
              {visibleSocial.map((l, i) => {
                const Icon = platformIcon(l.platform);
                const label = l.platform === "custom" && l.label ? l.label : platformLabel(l.platform);
                return (
                  <a
                    key={i}
                    href={l.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={label}
                    title={label}
                    data-testid={`footer-social-${l.platform}`}
                    className="group flex h-10 w-10 items-center justify-center rounded-full border border-white/10 bg-white/5 text-white/70 transition-all hover:border-white/25 hover:bg-white/10 hover:text-white"
                  >
                    <Icon width={16} height={16} />
                  </a>
                );
              })}
            </div>
          )}
        </div>
        <div>
          <h4 className="mb-4 text-xs font-semibold uppercase tracking-[0.2em] text-white/40">
            Explore
          </h4>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/services" className="hover:text-white">Services</Link></li>
            <li><Link to="/portfolio" className="hover:text-white">Portfolio</Link></li>
            <li><Link to="/about" className="hover:text-white">About</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="mb-4 text-xs font-semibold uppercase tracking-[0.2em] text-white/40">
            Contact
          </h4>
          <ul className="space-y-3 text-sm text-white/70">
            <li className="flex items-start gap-2">
              <Mail size={14} className="mt-1 text-fuchsia-400" />
              <a href={`mailto:${contact?.email || "info@creativetribe.online"}`} className="hover:text-white">
                {contact?.email || "info@creativetribe.online"}
              </a>
            </li>
            <li className="flex items-start gap-2">
              <Phone size={14} className="mt-1 text-fuchsia-400" />
              <a href={`tel:${(contact?.phone || "+1-647-569-782").replace(/[^+\d]/g, "")}`} className="hover:text-white">
                {contact?.phone || "+1-647-569-782"}
              </a>
            </li>
            <li className="flex items-start gap-2">
              <MapPin size={14} className="mt-1 text-fuchsia-400" />
              <span>{contact?.address || "Toronto, Ontario, Canada"}</span>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-2 px-6 py-6 text-xs text-white/40 md:flex-row md:items-center">
          <span>© {new Date().getFullYear()} Creative Tribe. All rights reserved.</span>
          <span className="tracking-[0.2em]">DESIGN · DIGITAL · GROWTH</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
